import script from "./Tutorial.vue?vue&type=script&setup=true&lang=js"
export * from "./Tutorial.vue?vue&type=script&setup=true&lang=js"

import "./Tutorial.vue?vue&type=style&index=0&id=9c6f99c4&lang=scss&scoped=true"
import "./Tutorial.vue?vue&type=style&index=1&id=9c6f99c4&lang=scss"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c6f99c4"]])

export default __exports__